//IMPORTS
import React, { useState } from "react";

import "../scss/Gallery.scss";

import { images } from "../constants/images";
import { Modal } from "../components/Gallery/Modal";

export const Gallery = () => {
  //
  const [isModal, setModal] = useState(false);
  const [image, setImage] = useState(null);

  const imageHandler = (image) => {
    setImage(image);
    setModal(true);
  };

  return (
    <main className='gallery'>
      <div className='container'>
        <div className='wrapper'>
          {isModal && <Modal setModal={setModal} image={image} />}
          <section>
            <div
              className='hero'
              onClick={() => {
                imageHandler(images.i4973);
              }}
            >
              <img src={images.i4973.imageTiny} alt='' />
            </div>

            <div
              className='square'
              onClick={() => {
                imageHandler(images.i5093);
              }}
            >
              <img src={images.i5093.imageTiny} alt='' />
            </div>

            <div
              className='square'
              onClick={() => {
                imageHandler(images.i5043);
              }}
            >
              <img src={images.i5043.imageTiny} alt='' />
            </div>

            <div
              className='horizontal'
              onClick={() => {
                imageHandler(images.i5072);
              }}
            >
              <img src={images.i5072.imageTiny} alt='' />
            </div>

            <div
              className='horizontal'
              onClick={() => {
                imageHandler(images.i5032);
              }}
            >
              <img src={images.i5032.imageTiny} alt='' />
            </div>

            <div
              className='hero'
              onClick={() => {
                imageHandler(images.i4976);
              }}
            >
              <img src={images.i4976.imageTiny} alt='' />
            </div>
            <div
              className='horizontal'
              onClick={() => {
                imageHandler(images.i5038);
              }}
            >
              <img src={images.i5038.imageTiny} alt='' />
            </div>
            <div
              className='vertical'
              onClick={() => {
                imageHandler(images.i4991);
              }}
            >
              <img src={images.i4991.imageTiny} alt='' />
            </div>
            <div
              className='horizontal'
              onClick={() => {
                imageHandler(images.i5063);
              }}
            >
              <img src={images.i5063.imageTiny} alt='' />
            </div>
            <div
              className='square'
              onClick={() => {
                imageHandler(images.i5004);
              }}
            >
              <img src={images.i5004.imageTiny} alt='' />
            </div>
            <div
              className='square'
              onClick={() => {
                imageHandler(images.i5109);
              }}
            >
              <img src={images.i5109.imageTiny} alt='' />
            </div>
            <div
              className='hero'
              onClick={() => {
                imageHandler(images.i5090);
              }}
            >
              <img src={images.i5090.imageSmall} alt='' />
            </div>
            <div
              className='square'
              onClick={() => {
                imageHandler(images.i5057);
              }}
            >
              <img src={images.i5057.imageTiny} alt='' />
            </div>
            <div
              className='horizontal'
              onClick={() => {
                imageHandler(images.i4969);
              }}
            >
              <img src={images.i4969.imageTiny} alt='' />
            </div>
            <div
              className='horizontal'
              onClick={() => {
                imageHandler(images.i4995);
              }}
            >
              <img src={images.i4995.imageTiny} alt='' />
            </div>
            <div
              className='horizontal'
              onClick={() => {
                imageHandler(images.i5085);
              }}
            >
              <img src={images.i5085.imageTiny} alt='' />
            </div>
          </section>
        </div>
      </div>
    </main>
  );
};
